import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Component } from "react";
import { Field } from "redux-form";
// import { Field } from "react-final-form";
import SmartDropdown from "./SmartDropdown";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
const styles = {
  smart_dp_required: {
    // "padding-top": "2px",
    // marginTop: 6,
  },
  inputSelectMaterial: {
    marginTop: 6
  },
  smart_label: {
    fontSize: 12,
    width: '100%'
  },
  errorMessage: {
    color: "red",
    fontSize: "12px"
  }
};
class InputSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
  }
  componentDidUpdate() {
    if (this.props.editStatus) {
      if (this.props.validation.length > 0 && this.props.collapsible) {
        this.props.toggleSection(true);
      }
    }
  }
  renderOptions() {
    return this.props.options.map((opt, i) => /*#__PURE__*/React.createElement(MenuItem, {
      key: i,
      value: opt.value
    }, opt.text));
  }
  handleChangeRequirement(dataElementName, event, newValue, previousValue, name) {
    let dataElem = this.props.dataElementId;
    if (this.props.changeRequirement) this.props.changeRequirement(dataElem === undefined ? dataElementName : dataElem, event, newValue, previousValue, name);
  }
  handleBlurRequirement(dataElementName, event, newValue, previousValue, name) {
    this.handleChangeRequirement(dataElementName, event, newValue, previousValue, name);
  }
  render() {
    const _this$props = this.props,
      classes = _this$props.classes,
      context = _this$props.context;
    const renderSelectField = _ref => {
      let input = _ref.input,
        label = _ref.label,
        _ref$meta = _ref.meta,
        touched = _ref$meta.touched,
        error = _ref$meta.error,
        warning = _ref$meta.warning,
        children = _ref.children,
        custom = _objectWithoutProperties(_ref, ["input", "label", "meta", "children"]);
      const currentValue = input && input.value ? input.value : this.props.value;
      const optionMatch = this.props.options.find(option => option.value === currentValue);
      const optionValue = {
        value: optionMatch ? optionMatch.value : currentValue,
        label: optionMatch ? optionMatch.text : currentValue
      };
      return /*#__PURE__*/React.createElement("div", {
        className: classes.inputSelectMaterial
      }, !this.props.isSmart ? /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true
      }, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: "{this.props.name}"
      }, this.props.dataElementName), /*#__PURE__*/React.createElement(Select, Object.assign({
        className: this.props.className + (touched && error ? " errorText" : "")
      }, input, custom, {
        disabled: this.props.disabled,
        value: input && input.value ? input.value : this.props.value
      }), children)) : /*#__PURE__*/React.createElement("div", {
        className: classes.smart_dp_required
      }, /*#__PURE__*/React.createElement(SmartDropdown, Object.assign({
        hide: this.props.disabled,
        options: this.props.options,
        placeholder: "Select ".concat(this.props.name),
        validate: error && (touched || warning)
      }, input, {
        name: this.props.name
      }, custom, {
        id: "sel-" + input.name,
        optionValue: optionValue
      }))), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: this.props.disabled ? {
          display: "none"
        } : {
          display: "inline"
        },
        className: classes.errorMessage
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: this.props.disabled ? {
          display: "none"
        } : {
          display: "inline"
        },
        className: "errorText"
      }, warning)));
    };
    return /*#__PURE__*/React.createElement("div", {
      style: {
        textOverflow: "ellipsis",
        overflow: "hidden"
      }
    }, /*#__PURE__*/React.createElement(Field, {
      id: this.props.id,
      name: this.props.fieldName ? this.props.fieldName : this.props.name,
      component: renderSelectField,
      context: context,
      validate: this.props.validation,
      onChange: (event, newValue, previousValue, name) => {
        this.handleChangeRequirement(this.props.dataElementName, event, newValue, previousValue, name);
      },
      onBlur: (event, newValue, previousValue, name) => {
        this.handleBlurRequirement(this.props.dataElementName, event, newValue, previousValue, name);
      }
    }, this.renderOptions()));
  }
}
InputSelect.defaultProps = {
  disabled: true,
  name: null,
  value: "",
  className: null,
  options: [{
    value: "",
    text: "None"
  }]
};
export default withStyles(styles)(InputSelect);